import React from 'react'
import PropTypes from 'prop-types'
import { InformationCircleIcon } from '@heroicons/react/outline'
import Button from '../../../components/Button/Button'
import useScreen from '../../../hooks/useScreen'
import { handleConfirmDiscard } from '../../../utils/handleDiscard'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useAlert from '../../../hooks/useAlert'
import useAuth from '../../../hooks/useAuth'
import { useNetworkStatus } from '../../../utils/networkStatus'

const InformationCard = ({ message, request }) => {
    const { isMobile } = useScreen()
    const history = useHistory()
    const { user } = useAuth()
    const { isOffline } = useNetworkStatus()
    const { handleChangeAlert, handleChangeOpen } = useAlert()

    return (
        <div
            className={`w-full h-full bg-scheduledBg p-4 rounded-2xl border border-blue-200 flex ${
                isMobile
                    ? 'flex-col items-start gap-y-3'
                    : 'items-center gap-x-3.5'
            }`}
        >
            <InformationCircleIcon className="text-scheduledText w-5 h-5" />
            <div className="text-textDarkerGray font-medium text-sm leading-relaxed">
                {message || (
                    <div className="space-y-2">
                        <span>Your request is pending.</span>
                        <br />
                        <span>
                            It will be synced once you&apos;re back online.
                        </span>
                    </div>
                )}
            </div>
            <Button
                text="Discard Request"
                variant="tertiary"
                className={`${isMobile ? 'max-w-40' : 'ml-auto text-md'}`}
                onClick={() =>
                    handleConfirmDiscard(
                        request,
                        handleChangeAlert,
                        handleChangeOpen,
                        history,
                        user?.external_contact_id,
                        isOffline,
                    )
                }
            />
        </div>
    )
}

InformationCard.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    request: PropTypes.oneOfType([PropTypes.object, PropTypes.any]),
}

export default InformationCard
